// removed by extract-text-webpack-plugin
module.exports = {"root":"_1vigz"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/containers/CashierPaymentsMethod/CashierPaymentsMethod.scss
// module id = 150
// module chunks = 0 1